import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import Menu from "@/core/data/menu.json";

import menu from "@/types/menu"
interface searchdatas {
    icon1: string,
    icon2: string,
    path: string,
    title: string
}
interface search {
    icon1: string,
    icon2: string,
    path: string,
    title: string,
    bookmark: string
}
export const useMenuStore = defineStore("menu", () => {
    const data1 = ref(Menu.data);

    const data: menu[] = (JSON.parse(JSON.stringify(Menu.data)))

    const togglesidebar = ref<boolean>(true);
    const activeoverlay = ref<boolean>(true);
    const customizer = ref<string>("");
    const searchData = ref<searchdatas[]>([]);
    const searchDatas = ref<search[]>([]);
    const searchOpen = ref<boolean>(false);
    const hideRightArrowRTL = ref<boolean>(false)
    const hideLeftArrowRTL = ref<boolean>(true)
    const hideRightArrow = ref<boolean>(true)
    const hideLeftArrow = ref<boolean>(true)
    const width = ref<number>(0)
    const height = ref<number>(0)
    const margin = ref<number>(0)
    const menuWidth = ref<number>(0)
    const searchKey = ref('')
    let perentName = ref<string>('')
    let subName = ref<string>('')
    let childName = ref<string>('')
    let collapsess = ref<string>('')
    let bodyToggle = ref(false)
    let perentToggle = ref<boolean>(false)
    let subToggle = ref<boolean>(false)
    let childToggle = ref<boolean>(false)
    interface term {
        [key: string]: any;
    }
    interface terms {
        [key: string]: any;
    }
    onMounted(() => {
        if (window.innerWidth < 991) {
            togglesidebar.value = false
        }
    })
    function toggle_sidebar() {

        togglesidebar.value = !togglesidebar.value;
        if (window.innerWidth < 991) {
            activeoverlay.value = true;
        } else {
            activeoverlay.value = false;
        }
        activeoverlay.value = false;
    }
    function subMenuToggle(Name: string) {
        perentName.value = perentName.value != Name ? Name : ""
        perentToggle.value = perentName.value != "" ? true : false
    }
    function subChildMenu(subTitle: string) {
        subName.value = subName.value != subTitle ? subTitle : ''
        subToggle.value = subName.value != "" ? true : false
    }
    function childMenu(childTitle: string) {
        childName.value = childName.value != childTitle ? childTitle : "";
        childToggle.value = childName.value != '' ? true : false

    }
    function accordionCollapse(item: string) {
        collapsess.value = collapsess.value != item ? item : ""
        perentToggle.value = collapsess.value != "" ? true : false
    }
    function searchTerm(term: any) {

        const items: any = [];

        const searchval = term.toLowerCase()

        data1.value.filter((menuItems: any) => {

            if (menuItems.title?.toLowerCase().includes(term) && menuItems.type === 'link') {
                items.push(menuItems);
            }
            menuItems.children?.filter((subItems: any) => {
                if (subItems.title?.toLowerCase().includes(term) && subItems.type === 'link') {
                    subItems.icon1 = menuItems.icon1
                    items.push(subItems);

                }
                if (!subItems.children) return false;
                subItems.children?.filter((suSubItems: any) => {
                    if (suSubItems.title?.toLowerCase().includes(term)) {
                        suSubItems.icon1 = menuItems.icon1
                        items.push(suSubItems);
                    }
                })

            })
            searchData.value = items;
        })
    }
    function searchterm(terms: any) {
        const items: any = [];
        const searchval = terms.toLowerCase()

        data1.value.filter((menuItems: any) => {
            if (menuItems.title?.toLowerCase().includes(terms) && menuItems.type === 'link') {
                items.push(menuItems);
            }
            menuItems.children?.filter((subItems: any) => {
                if (subItems.title?.toLowerCase().includes(terms) && subItems.type === 'link') {
                    subItems.icon1 = menuItems.icon1
                    items.push(subItems);

                }
                if (!subItems.children) return false;
                subItems.children?.filter((suSubItems: any) => {
                    if (suSubItems.title?.toLowerCase().includes(terms)) {
                        suSubItems.icon1 = menuItems.icon1
                        items.push(suSubItems);
                    }
                })

            })
            searchDatas.value = items;
        })

    }

    function setNavActive(item: any) {
        if (!item.active) {


            data.forEach((a: any) => {

                if (data.includes(item))
                    a.active = false;
                if (!a.children) return false;
                a.children.forEach((b: any) => {
                    if (a.children.includes(item)) {
                        b.active = false;
                    }
                });
            });
        }
        item.active = !item.active;
        if (item.active) {
            bodyToggle.value = true
        }
        else {
            bodyToggle.value = false
        }
    }

    return {
        data,
        togglesidebar,
        activeoverlay,
        toggle_sidebar,
        setNavActive,
        customizer,
        searchTerm,
        searchterm,
        searchData,
        searchOpen,
        hideRightArrowRTL,
        hideLeftArrowRTL,
        hideRightArrow,
        hideLeftArrow,
        width,
        height,
        margin,
        menuWidth,
        searchDatas,

        data1,
        bodyToggle,
        subMenuToggle,
        subChildMenu,
        childMenu,
        perentName,
        subName,
        childName,
        perentToggle,
        subToggle,
        childToggle,
        accordionCollapse,
        collapsess
    };
});
